(function () {
  const initSlider = (section) => {
    const sliderEl = section.querySelector(".blog-articles-slider");
    if (!sliderEl) return;

    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 6);
    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );

    const articlesBlock = section.querySelector(".main-blog__articles");
    const nextBtn = articlesBlock
      ? articlesBlock.querySelector(".heading-group__navigation-button-next")
      : null;
    const prevBtn = articlesBlock
      ? articlesBlock.querySelector(".heading-group__navigation-button-prev")
      : null;
    const paginationElement = articlesBlock
      ? articlesBlock.querySelector(".heading-group__pagination")
      : null;

    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1100 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: slidesPerViewMobile,
      spaceBetween: 4,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationElement,
        type: "fraction",
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
          slidesPerGroup: slidesPerView576,
        },
        990: {
          slidesPerView: slidesPerView990,
          slidesPerGroup: slidesPerView990,
        },
        1100: {
          slidesPerView: slidesPerView1100,
          slidesPerGroup: slidesPerView1100,
        },
        1360: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
        },
      },
    };

    if (!sliderEl.swiper) new Swiper(sliderEl, sliderSettings);
  };

  const destroySlider = (section) => {
    const sliderEl = section.querySelector(".blog-articles-slider");
    if (!sliderEl) return;

    const articlesWrapper = sliderEl.querySelector(".blog-articles");
    if (sliderEl.swiper) sliderEl.swiper.destroy();
    sliderEl.querySelector(".swiper-wrapper")?.removeAttribute("style");
    if (articlesWrapper)
      articlesWrapper
        .querySelectorAll(".swiper-slide")
        .forEach((slide) => slide.removeAttribute("style"));
  };

  const initSectionLayout = (section) => {
    if (!section || !section.classList.contains("section-main-article")) {
      return;
    }

    const articlesBlock = section.querySelector(".main-blog__articles");
    if (!articlesBlock) return;

    const layout = articlesBlock.dataset.layout;

    if (layout === "slider") {
      initSlider(section);
    } else {
      destroySlider(section);
    }
  };

  initSectionLayout(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSectionLayout(event.target);
  });
})();
